import React from 'react';
import { Container, Button } from './styles';

interface ArrowProps {
  children: React.ReactNode;
  onClick: VoidFunction;
  disabled: boolean;
}

const ArrowLibrary: React.FC<ArrowProps> = ({
  children,
  onClick,
  disabled,
}) => {
  return (
    <Container>
      <Button disabled={disabled} type="button" onClick={onClick}>
        {children}
      </Button>
    </Container>
  );
};

export default ArrowLibrary;
